import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres6ae/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres6ae/labels')
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hres6ae/dropdowns')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_dtereq_st: (typeof searchParams.dtereqst !== 'undefined' ? searchParams.dtereqst : ''),
        p_dtereq_en: (typeof searchParams.dtereqen !== 'undefined' ? searchParams.dtereqen : '')
      }
    }
    return instance().get(endpoint + '/hres6ae/index', { params: sendParams })
  },
  getDetail (searchParams) {
    let sendParams = {
      p_dtereq: searchParams.dtereq,
      p_numseq: searchParams.numseq,
      p_dtework: searchParams.dtework,
      p_dteworkstrt: searchParams.dtework,
      p_dteworkend: searchParams.dtework
    }
    if (isMock) return generator(mocker.detail())
    const params = sendParams.p_dtereq.replace(/\//g, '') + '/' + sendParams.p_numseq + '/' + sendParams.p_dtework.replace(/\//g, '')
    return instance().get(endpoint + '/hres6ae/update/' + params)
  },
  getDetailSearch (searchParams) {
    let sendParams = {
      p_dteworkstrt: searchParams.dteworkst,
      p_dteworkend: searchParams.dteworken
    }
    if (isMock) return generator(mocker.detailSearch())
    const params = sendParams.p_dteworkstrt.replace(/\//g, '') + '/' + sendParams.p_dteworkend.replace(/\//g, '')
    return instance().get(endpoint + '/hres6ae/updateSearch/' + params)
  },
  postSave (dataRowsHasFlg) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres6ae/updateAll', dataRowsHasFlg)
  },
  postCancel (cancelParams) {
    if (isMock) return generator(mocker.cancel())
    return instance().post(endpoint + '/hres6ae/cancel', cancelParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres6ae/index.js